jQuery(document).ready(function ($) {
    'use strict';

    // console.log('Blog filter script loaded and ready.');

    const $blogGridContainer = $('#blog-grid-container');
    const $blogPostsRow = $('#blog-posts-row');
    const $blogPagination = $('#blog-pagination');

    if (!$blogGridContainer.length) {
        // console.log('Blog grid container NOT found on this page.');
        return;
    }

    if (typeof reim_ajax === 'undefined') {
        console.error('reim_ajax is not defined. AJAX will not work.');
        return;
    }

    // console.log('Blog filter AJAX initialized successfully.');

    // Use a very specific listener to override default link behavior
    $(document).on('click', '.blog-grid-section .filter-tab, .blog-grid-section #blog-pagination a', function (e) {
        // console.log('Tab or pagination clicked:', this.href);

        e.preventDefault();
        e.stopPropagation();

        const $this = $(this);
        let categoryId = 'all';
        let page = 1;

        if ($this.hasClass('filter-tab')) {
            categoryId = $this.data('category');
            // Update active state
            $('.filter-tab').removeClass('active');
            $this.addClass('active');
        } else {
            // Pagination click
            categoryId = $('.filter-tab.active').data('category') || 'all';
            // Extract page number from URL if possible, or use a default
            try {
                const url = new URL($this.attr('href'));
                page = url.searchParams.get('paged') || 1;
                if (!page) {
                    const match = url.pathname.match(/\/page\/(\d+)/);
                    if (match) page = match[1];
                }
            } catch (err) {
                console.error('URL parse error:', err);
            }
        }

        // console.log('Filtering blogs with action: reim_filter_blogs', { categoryId, page });

        // Loading state
        $blogGridContainer.addClass('loading');

        $.ajax({
            url: reim_ajax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'reim_filter_blogs',
                category: categoryId,
                paged: page,
                nonce: reim_ajax.nonce
            },
            success: function (response) {
                // console.log('AJAX Response:', response);
                if (response.success) {
                    $blogPostsRow.html(response.data.posts);
                    $blogPagination.html(response.data.pagination);

                    // Update URL without reloading
                    const newUrl = $this.attr('href');
                    window.history.pushState({ path: newUrl }, '', newUrl);

                    // console.log('Blogs filtered successfully.');
                } else {
                    $blogPostsRow.html('<div class="col-12 text-center"><p>' + response.data + '</p></div>');
                    $blogPagination.empty();
                    // console.warn('Filter error:', response.data);
                }
            },
            error: function (xhr, status, error) {
                console.error('AJAX Error:', error);
                console.log('XHR:', xhr);
            },
            complete: function () {
                $blogGridContainer.removeClass('loading');

                // Smooth scroll back to grid top
                $('html, body').animate({
                    scrollTop: $blogGridContainer.offset().top - 150
                }, 500);
            }
        });

        return false;
    });
});
